export default function PageShell({ title }) {
  return (
    <div className="p-8" data-testid={`page-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <h1 className="text-4xl font-bold text-gray-900">{title}</h1>
    </div>
  );
}
